<template>
  <div class="t-orderlist">
    <div class="t-order-list">
      <p class="t-order-indent">订单列表</p>
      <div class="t-order-state">
        <p
          v-for="(status, index) in statusList"
          :key="status.label"
          :class="{ orderStyle: index == orderStatus }"
          @click="handleOrderStatusChange(index)">
          {{ status.text }} 
          <span v-if="status.num">({{ status.num }})</span>
        </p>
      </div>
    </div>
    <div class="t-table">
      <el-table
        @sort-change='handleListSortChange'
        :data="list"
        size="mini"
        border
        >
        <el-table-column
          prop="order_id"
          min-width="120"
          label="订单号">
          <template slot-scope="scope">
            <span class="square-button green" @click="handleShowOrderDetail(scope.row.order_id)">详</span>
            <span class="square-button blue" v-if="scope.row.order_supplier_type === 2" style="cursor: default;">外</span>
            <span class="square-button red"
                  @click="handleOrderMode(scope.row)"
                  v-else-if="scope.row.order_supplier_type === 1 && scope.row.is_supplement != 1 && scope.row.is_grab != 1">图</span>
            {{scope.row.order_id}}
            <span class="circle circle--gray" v-if="scope.row.is_supplement == 1" title="补单不提供地图模式">补</span>
            <span class="circle circle--gray" v-if="scope.row.is_grab == 1" title="抢单不提供地图模式">抢</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="order_time"
          sortable='custom'
          label="下单时间">
          <template slot-scope="scope">
            <span class="circle circle--red" v-if="scope.row.delivery_type === 1">即</span>
            <span class="circle circle--blue" v-else>预</span>
            {{ scope.row.order_time }}
          </template>
        </el-table-column>
        <el-table-column
          prop="expect_time"
          sortable='custom'
          label="期望时间">
          <template slot-scope="scope">
            {{ scope.row.expect_time }}
          </template>
        </el-table-column>
        <el-table-column
          min-width="200"
          label="餐厅/用户">
          <template slot-scope="scope">
            <span class="circle circle--red" v-if="scope.row.dispatch_type !== 1">驻</span>
            <span>{{ scope.row.shop_name }}（{{ scope.row.brand_abbr }}）</span> /
            <span>{{ scope.row.user_address }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="total_price"
          min-width="70"
          label="金额">
          <template slot-scope="scope">
            ￥{{ scope.row.total_price  }}
          </template>
        </el-table-column>
        <el-table-column
          prop="total_distance"
          min-width="70"
          label="送餐距离">
          <template slot-scope="scope">
            {{ scope.row.total_distance }}km
          </template>
        </el-table-column>
        <el-table-column
          prop="rider_name"
          min-width="70"
          label="骑手">
          <template slot-scope="scope">
            <span class="square-button blue" v-if="scope.row.order_supplier_type === 2" style="cursor: default;">外</span>
            <span class="square-button red" @click="handleRiderOrderMode(scope.row)" v-else-if="scope.row.order_supplier_type === 1 && scope.row.rider_name">图</span>
            {{ scope.row.rider_name }}
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-bar">
        <el-pagination
          small
          @current-change="handleCurrentPageChange"
          :page-size="pagination.perpage"
          :current-page="currentPage"
          layout="prev, pager, next, total"
          :total="pagination.total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import { formatDate } from 'common/utils';
import { COMMON_ORDER_STATUS } from 'common/constant';
import { NAMESPACE, UPDATE_SEARCH_CONDITION } from '../store/modules/orderList';
import { UPDATE_ORDER_DETAIL } from '../store/mutation-types';

export default {
  name: 'OrderList',
  data() {
    return {
      prop: '',
      order: '',
      height: 700,
    };
  },
  computed: {
    ...mapState(NAMESPACE, [
      'list',
      'statusList',
      'pagination',
      'currentPage',
      'orderStatus',
    ]),
    ...mapState({
      timestamp: state => state.timestamp,
      date: ({ aside }) => aside.date,
    }),
    ...mapGetters(['AoiShopMsg']),
  },
  watch: {
    AoiShopMsg(val) {
      if (val) {
        this.getOrderListData();
        this.getPendingListData();
      } else {
        this.resetAllListData();
      }
    },
    date() {
      this.getOrderListData();
      this.getPendingListData();
    },
    timestamp() {
      this.getOrderListData();
      this.getPendingListData();
    },
  },
  methods: {
    ...mapActions(NAMESPACE, [
      'getOrderListData',
      'resetAllListData',
      'getPendingListData',
      'handleOrderStatusChange',
      'handleCurrentPageChange',
      'handleListSortChange',
    ]),
    ...mapMutations(NAMESPACE, {
      updateSearchCondition: UPDATE_SEARCH_CONDITION,
    }),
    ...mapMutations({
      updateOrderDetail: UPDATE_ORDER_DETAIL,
    }),
    getStatus(status) {
      for (let i = 0; i < COMMON_ORDER_STATUS.length; i++) {
        if (COMMON_ORDER_STATUS[i].state === status.toString()) {
          return COMMON_ORDER_STATUS[i].name;
        }
      }
      return status;
    },
    handleOrderMode(data) {
      const time = data.distribute_time || data.list_time;
      const href = `orderview.html#/order/${data.order_id}/${time}`;
      window.open(href);
    },
    handleRiderOrderMode(data) {
      const href = `rider.html?ridername=${data.rider_name}#/rider/ordermode/${data.rider_id}/${this.timestamp}`;
      window.open(href);
    },
    handleShowOrderDetail(orderid) {
      this.updateOrderDetail({
        open: true,
        orderid,
      });
    },
    convertDate(timestamp) {
      if (timestamp) {
        return formatDate(new Date(timestamp * 1000), 'MM-dd hh:mm:ss');
      }
      return timestamp;
    },
  },
};
</script>

<style lang="less">
  .t-orderlist {
    min-width: 890px;
    flex-grow: 1;
    flex-shrink: 1;
    margin-left: 20px;
    background: #fff;
    padding: 20px;
    display: flex;
    flex-direction: column;
    .el-form-item__label {
      font-size: 12px;
    }
    .el-input--mini {
      width: 140px;
    }
    .el-table {
      color: #666;
    }
    .t-order-list {
      display: flex;
      align-items: flex-start;

      .t-order-indent {
        width: 100px;
        height: 33px;
        font-size: 24px;
        margin-right: 12px;
      }
      .t-order-state {
        .orderStyle {
          border-bottom: 3px solid #333;
        }
        p {
          height: 20px;
          float: left;
          font-size: 14px;
          color: #666;
          margin: 0 20px 20px 0;
          cursor: pointer;
          padding: 5px;
        }
      }
    }

    .el-table thead th {
      padding: 0;
      color: #666;
      background: #F6F6F6;
    }
    
  }
  .t-table {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 90%;
    .el-table__body-wrapper {
      height: calc(100% - 35px) !important;
      overflow-y: scroll;
    }
    .pagination-bar {
      padding-top: 20px;
      flex: 0;
      .el-pagination {
        float: left;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/homepage/modules/OrderList.vue